import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpService} from '../http.service';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(private httpService: HttpService,
              private router: Router) { }

  private customerPath = 'customer';
  private customerSearchPath = 'customers';
  private customerUrl = '/customer/';

  getCustomer(customerID): Observable<any>{
    return this.httpService.httpGet(this.customerPath + '/' + customerID).pipe(response => {
      return response;
    });
  }

  openCustomer(customerID){
    this.router.navigate([this.customerUrl, customerID]);
  }


  getCustomers(term, page): Observable<any> {
    const t = (term !== '') ? '/' + term : '';
    return this.httpService.httpGet(this.customerSearchPath + t + '?page=' + page ).pipe(response => {
      return response;
    });
  }
}
